import React from 'react'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { ChartsTooltipContainer, useAxesTooltip } from '@mui/x-charts/ChartsTooltip'

/* Custom tooltip to remove markelements in chart tooltips, since hideTooltip prop doesn't work */
export function CustomAxisTooltip() {
    const tooltipData = useAxesTooltip()

    if (!tooltipData || tooltipData.length === 0) {
        return <ChartsTooltipContainer trigger='axis' />
    }

    return (
        <ChartsTooltipContainer trigger='axis'>
            <Paper
                elevation={0}
                sx={{
                    m: 1,
                    p: 1,
                    tbody: {
                        tr: {
                            td: {
                                paddingRight: '5px',
                                paddingBottom: '5px',
                            },
                        },
                    },
                }}
            >
                <table>
                    <tbody>
                        {tooltipData[0].seriesItems.map((seriesItem) => (
                            <tr key={seriesItem.seriesId}>
                                <td>
                                    <div
                                        style={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: 5,
                                            backgroundColor: seriesItem.color,
                                        }}
                                    />
                                </td>
                                <td>
                                    <Typography>{seriesItem.formattedLabel}</Typography>
                                </td>
                                <td>
                                    <Typography>{seriesItem.formattedValue}</Typography>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Paper>
        </ChartsTooltipContainer>
    )
}
